module.exports = __webpack_public_path__ + "img/theme9.889e9e92.png";